import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Loading } from 'src/app/Class/Loading';
import { Router, ActivatedRoute } from '@angular/router';
import { IntegrantesUnidadesService } from 'src/app/servicios/integrantes-unidades.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-integrantes-unidades',
  templateUrl: './integrantes-unidades.component.html',
  styleUrls: ['./integrantes-unidades.component.css']
})
export class IntegrantesUnidadesComponent implements OnInit, OnDestroy {

  public dtOptions: DataTables.Settings = Object.assign({}, DTConfig.dtConf);
  public dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  idEntidad: number;
  public personas: any = [];
  public entidad: any = {};
  public integrantes: any = [];
  public formintegrantes: FormGroup;
  public tipointegrante = [{ id: true, nombre: 'Director' }, {id: false, nombre: 'Integrante'}];
  index: any;


  constructor( private service: IntegrantesUnidadesService,
               private route: ActivatedRoute,
               private router: Router,
               private fb: FormBuilder,
               public loading: Loading ) {

                this.loading.estado = true;
                this.route.params
                    .subscribe(parametros => {

                      this.idEntidad = parametros['id'];
                      this.dtTrigger = new Subject();

                      this.service.getIntegrantes(this.idEntidad)
                          .subscribe( (data:any) => {
                            this.personas = data.personas ? data.personas : [];
                            this.entidad = data.entidad ? data.entidad : {};
                            this.integrantes = this.entidad ? this.entidad.integrantes : [];
                            this.dtTrigger.next();
                            this.loading.estado = false;
                          },
                          err => {  this.loading.estado = false; }
                          );
                    });

                this.formintegrantes = this.fb.group({
                  unidad_id : [''],
                  persona_id: ['', Validators.required],
                  director: ['', Validators.required],
                });
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  agregarIntegrante() {
    this.index = null;
    this.formintegrantes.reset({ unidad_id: this.idEntidad});
    $('#exampleModal').modal({ backdrop: 'static', keyboard: true, show: true });
  }

  editar(datos, index) {
    this.index = index;
    // tslint:disable-next-line: forin
    for ( const nombre  in this.formintegrantes.value) {
           this.formintegrantes.get(nombre).setValue(datos[nombre]);
         }
    this.formintegrantes.get('unidad_id').setValue(this.idEntidad);
    $('#exampleModal').modal({ backdrop: 'static', keyboard: true, show: true });
  }

  public guardar() {
    
    if(this.formintegrantes.value.director == true)
    {
      if( this.integrantes.find( x => x.director == true ) ){
        Swal.fire({ type: 'info', title: 'No se puedeingresar más de un director', timer: 1500 });
        return;
      }
    }

    this.loading.estado = true;
    this.service.Guardarintegrante(this.formintegrantes.value)
    .subscribe(data => {
      if (data['success']) {
        if (this.index != null) {
        this.integrantes[this.index] = data['integrante'];
       } else {
        this.integrantes.push(data['integrante']);
       }
        $('#exampleModal').modal('hide');
        Swal.fire({ type: 'success', title: 'Guardado exitoso', timer: 1500 });
      } else {
        Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
      }
      this.rerender();
      this.loading.estado = false;
    });

  }

  registroPersona() {
    $('#exampleModal').modal('hide');
    this.router.navigate(['/personas']);
  }

  eliminar(datos, index) 
  {
    Swal.fire({ type: 'info', title: '¿Está seguro de eliminar al integrante?', text: '', showCancelButton:true, confirmButtonText:'Si' })
    .then( (resp)=>{
      if(resp.value)
      { 
         this.delete(datos, index);
      }
    });
  }

  delete(datos, index){
    this.loading.estado = true;

    let dts = { persona_id: datos.persona_id, unidad_id: this.idEntidad  };

    this.service.Eliminarintegrante(dts)
    .subscribe(data => {
      if (data['success']) {
        this.integrantes.splice(index, 1);
        this.rerender();
        Swal.fire({ type: 'success', title: 'Eliminación exitosa', timer: 1500 });
      } 
      else {
        Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
      }
      this.loading.estado = false;
    });
  }

}
